export default {"src":"/_next/static/media/pendo.b12a2293.svg","height":26,"width":112,"blurWidth":0,"blurHeight":0};